import { convertToDate } from "utils";
import fields from "../Field.constants";
import { updateEMarkingStartDate, updateEMarkingEndDate } from "./isUpdating";

function eMarkingDateUpdatesAreInvalid(appointments, updates) {
    if (!updateEMarkingStartDate(updates) && !updateEMarkingEndDate(updates)) {
        return false;
    }

    const startValue = convertToDate(updates.find(u => u.field === fields.E_MarkingStartDate)?.value);
    const endValue = convertToDate(updates.find(u => u.field === fields.E_MarkingEndDate)?.value);

    if (startValue && endValue) {
        return startValue > endValue;
    }

    return appointments.findIndex(appointment => {
        const startDate = convertToDate(appointment.eMarkingStartDate);
        const endDate = convertToDate(appointment.eMarkingEndDate);
        return (startValue && startValue > endDate) ||
            (endValue && startDate > endValue);
    }) !== -1;
}

export default eMarkingDateUpdatesAreInvalid;